import { render } from "./VabeneGalleryPage.vue?vue&type=template&id=2bf21ba4&ts=true"
import script from "./VabeneGalleryPage.vue?vue&type=script&lang=ts"
export * from "./VabeneGalleryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__